// @charset "utf-8";
/* global TA */
import Vue from 'vue'
import axios from 'axios'

const ctx = '@@stat'
const prefix = 'smzj'
const platform = 'browser'
const ua = 'pc'
const log = ({ section, act, userid, uid, ...others }) => TA.log({ id: act ? `${prefix}_${ua}_${section}.${act}` : `${prefix}_${ua}_${section}`, ld: platform, userid: userid, uid, ...others })
const getCookie = cname => {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(name) !== -1) {
            return c.substring(name.length, c.length)
        }
    }
    return ''
}

const getUid = () => {
    let userid = localStorage.getItem('userid')
    return new Promise((resolve, reject) => {
        if (userid) resolve(userid)
        else {
            axios.get('//www.forfunds.cn/platform/id').then(response => {
                localStorage.setItem('userid', response.data)
                resolve(response.data)
            }, error => {
                reject(error)
            })
        }
    })
}

const bind = async (el, value, modifiers) => {
    if (window.__PRERENDER_INJECT) return
    if (!value) return
    let { act, section, event } = value
    let { stop } = modifiers
    if (event === 'ready') {
        let uid = await getUid()
        let userid = getCookie('userid')
        return log({ section, act, userid, uid })
    }
    event = event || 'click'
    el[ctx] = {
        event,
        section,
        act,
        async bindingFn (e) {
            let uid = await getUid()
            let userid = getCookie('userid')
            let act = el[ctx].act // 处理解绑的情况
            if (stop) {
                e.stopPropagation ? e.stopPropagation() : (e.cancelBubble = true)
            }
            setTimeout(() => log({ section: el[ctx] ? el[ctx].section : section, act: el[ctx] ? el[ctx].act : act, userid: userid, uid }), 0) // 尽量在更新后输出
        }
    }
    el.addEventListener(el[ctx].event, el[ctx].bindingFn, false)
}

const unbind = (el) => {
    el.removeEventListener(el[ctx].event, el[ctx].bindingFn, false)
    el[ctx] = undefined
}

Vue.directive('stat', {
    bind (el, { value, modifiers }) {
        bind(el, value, modifiers)
    },
    unbind (el) {
        if (el[ctx]) {
            unbind(el)
        }
    },
    update (el, { value }) {
        if (el[ctx] && value) {
            el[ctx].section = value.section
            el[ctx].act = value.act
        }
    },
    componentUpdated (el, { value, modifiers }) {
        if (el[ctx]) {
            if (value) {
                el[ctx].act = value.act
            } else {
                unbind(el)
            }
        } else {
            if (value && value.event !== 'ready') {
                bind(el, value, modifiers)
            }
        }
    }
})

export {
    log
}



// WEBPACK FOOTER //
// ./src/lib/stat.js